export const ITEM_AVAILABILITY = {
  public: 'public',
  private: 'private'
}

export const VISIBILITY_STATES = {
  online: 1,
  offline: 2,
  scheduled: 3,
  draft: 4
}

export const ITEM_INITIAL_VALUES = {
  categories_ids: [],
  tags: {},
  image: {},
  item_visibility: { status: VISIBILITY_STATES.online },
  audience_permissions: { },
  is_public: true,
  availability: ITEM_AVAILABILITY.public,
  can_edit_content: true
}

export const CONTENT_ITEM_INITIAL_VALUES = {
  is_draft: false,
  image: {},
  tags: {},
  is_public: true,
  availability: ITEM_AVAILABILITY.public,
  can_edit_content: true
}

export const ITEM_TYPE_FILTERS = [
  { id: 'all', label: 'All Types', default: true, is_all: true },
  { id: 'image', label: 'Image' },
  { id: 'video', label: 'Video' },
  { id: 'link', label: 'URL' },
  { id: 'document', label: 'Document' },
  { id: 'article', label: 'Article' }
]
